import script from "./HostingDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./HostingDetail.vue?vue&type=script&setup=true&lang=js"

import "./HostingDetail.vue?vue&type=style&index=0&id=1c69daf7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c69daf7"]])

export default __exports__